import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as utils from '../../../utils/utilities';
import * as models from '../../../utils/models';

class HelideckDropPhotoForm extends Form {
	state = {
		data: {
			generalView: [],
			perimeterNet: [],
			netInGoodCondition: [],
			dummySetUp: [],
			executingDropTest: [],
			others: [],
		},
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		generalView: Joi.array().min(1).required().label('General View'),
		perimeterNet: Joi.array().min(1).required().label('Perimeter Net'),
		netInGoodCondition: Joi.array()
			.min(1)
			.required()
			.label('Perimeter net in good condition'),
		dummySetUp: Joi.array().min(1).required().label('Personnel Gridlines'),
		executingDropTest: Joi.array()
			.min(1)
			.required()
			.label('Carrying out of drop test'),
		others: Joi.array().min(1).required().label('Other Related Images'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.mapDataToArray());
	};

	mapDataToArray = (): models.PDFImageProps[] => {
		const images: models.PDFImageProps[] = [];

		for (const key in this.state.data) {
			images.push(...(this.state.data as any)[key]);
		}

		return images;
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				<div className="row">
					<div className="col">
						{this.renderFileInput({
							max: 4,
							multiple: true,
							name: 'generalView',
							accept: 'image/*,application/pdf',
							label: 'General View',
							sublabel: 'General view of the helideck',
							types: utils.getFileUploadTypes(),
						})}
					</div>
					<div className="col">
						{this.renderFileInput({
							max: 4,
							multiple: true,
							name: 'perimeterNet',
							accept: 'image/*,application/pdf',
							label: 'Perimeter Net',
							sublabel: 'Perimeter Net after numbering for drop test',
							types: utils.getFileUploadTypes(),
						})}
					</div>
				</div>

				<div className="row">
					<div className="my-4 divider"></div>
					<div className="col">
						{this.renderFileInput({
							max: 4,
							multiple: true,
							name: 'netInGoodCondition',
							accept: 'image/*,application/pdf',
							label: 'Perimeter Net in Good Condition',
							sublabel: 'View of Perimeter net in good condition.',
							types: utils.getFileUploadTypes(),
						})}
					</div>
					<div className="col">
						{this.renderFileInput({
							max: 4,
							multiple: true,
							name: 'dummySetUp',
							accept: 'image/*,application/pdf',
							label: 'Dummy Set Up',
							sublabel:
								'Personnel setting up dummy in preparation for Drop test.',
							types: utils.getFileUploadTypes(),
						})}
					</div>
				</div>

				<div className="row">
					<div className="my-4 divider"></div>
					<div className="col">
						{this.renderFileInput({
							max: 4,
							multiple: true,
							name: 'executingDropTest',
							accept: 'image/*,application/pdf',
							label: 'Carrying out of drop test',
							sublabel: 'Carrying out of drop test on helideck perimeter net.',
							types: utils.getFileUploadTypes(),
						})}
					</div>

					<div className="col">
						{this.renderFileInput({
							max: 4,
							multiple: true,
							name: 'others',
							accept: 'image/*,application/pdf',
							label: 'Others',
							sublabel: 'Upload other related images.',
							types: utils.getFileUploadTypes(),
						})}
					</div>
				</div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default HelideckDropPhotoForm;
